export const tab = {
  TRACE_INFO: 'Trace info',
  OVERVIEW: 'Overview'
};
